export const navLinks = [
  { id: "about", label: "品牌介绍" },
  { id: "features", label: "核心功能" },
  { id: "app", label: "APP" },
  { id: "clients", label: "客户端" },
  { id: "membership", label: "会员体系" },
  { id: "vip", label: "VIP 特权" },
  { id: "danmaku", label: "弹幕" },
  { id: "collections", label: "片单收藏" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "多端", label: "手机·平板·电视·网页" },
  { value: "多档", label: "清晰度自由切换" },
  { value: "同步", label: "账号进度与片单一致" },
  { value: "弹性", label: "弹幕可开可关" },
];

export const aboutPoints = [
  {
    icon: "ri-compass-3-line",
    title: "内容组织清晰",
    desc: "按类型、地区、年份与题材多维度组织内容，进入后不必反复翻找，先从大方向缩小范围，再挑选具体条目。",
  },
  {
    icon: "ri-play-circle-line",
    title: "播放体验稳定",
    desc: "提供多档清晰度选择，弱网环境自动降低码率保证连续播放，强网环境可切换到更高清画质。",
  },
  {
    icon: "ri-account-circle-line",
    title: "账号体系统一",
    desc: "APP、客户端与网页端共用同一账号，收藏、观看进度与追更列表在各端保持一致，换设备无需重新整理。",
  },
];

export const featureList = [
  {
    icon: "ri-layout-grid-line",
    title: "多维片库导航",
    desc: "类型、地区、年份、题材四个维度交叉筛选，快速把范围缩小到少数候选，避免在庞杂列表中来回翻页。",
  },
  {
    icon: "ri-hd-line",
    title: "多档清晰度",
    desc: "根据网络情况在标清、高清与超清之间切换，播放器会给出当前码率与清晰度提示，选择结果会被记住。",
  },
  {
    icon: "ri-magic-line",
    title: "个性化推荐",
    desc: "结合观看历史、收藏与停留时长生成推荐列表，推荐结果按相似度排序，越用越贴近个人口味。",
  },
  {
    icon: "ri-device-line",
    title: "跨端进度同步",
    desc: "在手机看到一半，回到电视或网页端可从大致相同位置继续，减少手动拖拽进度条的时间成本。",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "弹幕互动",
    desc: "可开启或关闭的实时弹幕，支持透明度、字号与滚动速度调节，并提供关键词过滤减少干扰。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "收藏与追更",
    desc: "一键收藏感兴趣的内容，追更提醒会在有新内容时给出提示，所有关注项集中在一个片单里管理。",
  },
];

export const appHighlights = [
  "安装包体积适中，安装后可直接进入内容列表，无需繁琐的初始设置流程。",
  "支持后台播放与息屏继续听，适合通勤或做家务时以音频方式继续内容。",
  "提供省流模式，在流量环境下自动限制清晰度，减少不必要的数据消耗。",
  "内置夜间与护眼配色，长时间观看时降低屏幕刺眼程度。",
];

export const appSteps = [
  { step: "01", title: "确认设备", desc: "在手机或平板上确认系统版本满足基本要求，预留足够存储空间用于安装与缓存。" },
  { step: "02", title: "获取安装包", desc: "通过官方渠道获取安装包，避免使用来源不明的第三方文件，安装前核对文件信息。" },
  { step: "03", title: "完成安装", desc: "按系统提示允许安装未知来源应用，安装完成后首次打开授予必要的网络与存储权限。" },
  { step: "04", title: "登录与同步", desc: "使用同一账号登录，收藏、片单与观看进度会自动拉取并保持各端一致。" },
];

export const clients = [
  {
    id: "ios",
    name: "iOS 客户端",
    icon: "ri-apple-fill",
    tagline: "为 iPhone 与 iPad 优化",
    desc: "针对苹果设备的操作习惯与屏幕比例做了适配，支持手势返回、画中画与投屏接力，横屏与竖屏切换时布局自动重排。",
    points: [
      "支持画中画，切到其它应用时继续小窗播放。",
      "适配灵动岛与锁屏控制，不解锁也能暂停与切换。",
      "与 iCloud 备份共存，重装后登录即可恢复账号数据。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20flat-lay%20of%20a%20smartphone%20showing%20a%20minimal%20streaming%20app%20interface%20with%20orange%20accents%2C%20amber%20and%20cream%20color%20palette%2C%20soft%20studio%20lighting%2C%20clean%20uncluttered%20background%2C%20subtle%20film%20grain%20texture%2C%20editorial%20product%20photography&width=900&height=1100&seq=client-ios-01&orientation=portrait",
  },
  {
    id: "android",
    name: "Android 客户端",
    icon: "ri-android-fill",
    tagline: "适配主流安卓机型",
    desc: "覆盖常见分辨率与屏幕比例，针对不同芯片平台做解码优化，老旧机型也能保持较稳定的基础播放。",
    points: [
      "支持硬解与软解自动切换，兼容更多机型。",
      "提供省电模式，长时间观看时降低功耗。",
      "支持外置存储缓存路径选择，释放机身空间。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20flat-lay%20of%20an%20android%20phone%20displaying%20a%20media%20library%20grid%20in%20warm%20amber%20and%20rust%20tones%2C%20clean%20minimal%20background%2C%20soft%20directional%20lighting%2C%20subtle%20texture%2C%20elegant%20editorial%20product%20photography&width=900&height=1100&seq=client-android-01&orientation=portrait",
  },
  {
    id: "tv",
    name: "智能电视 / TV 版",
    icon: "ri-tv-2-line",
    tagline: "大屏与遥控器操作",
    desc: "为客厅大屏设计，界面元素按遥控器焦点导航，字号与间距适配远距离观看，减少走近操作的次数。",
    points: [
      "遥控器方向键操作，焦点清晰易识别。",
      "大字号片名与简介，坐远也能看清。",
      "支持大屏独立账号绑定，与手机端进度互通。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20living%20room%20scene%20with%20a%20large%20television%20showing%20a%20minimal%20media%20browse%20interface%20in%20amber%20and%20deep%20rust%20tones%2C%20cozy%20low%20light%2C%20soft%20glow%2C%20clean%20modern%20interior%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field&width=1400&height=900&seq=client-tv-01&orientation=landscape",
  },
  {
    id: "web",
    name: "网页版",
    icon: "ri-global-line",
    tagline: "免安装，浏览器直达",
    desc: "不需要安装任何程序，在浏览器中登录即可浏览与播放，适合临时使用或公用设备，关闭窗口后不留安装痕迹。",
    points: [
      "免安装，打开浏览器即可使用。",
      "与 APP 共用账号，收藏与进度同步。",
      "支持全屏与快捷键操作，键盘用户友好。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20desktop%20workspace%20with%20a%20laptop%20showing%20a%20clean%20streaming%20web%20interface%20in%20amber%20and%20cream%20tones%2C%20soft%20natural%20window%20light%2C%20minimal%20desk%2C%20elegant%20editorial%20photography%20with%20warm%20shadows&width=1400&height=900&seq=client-web-01&orientation=landscape",
  },
];

export const memberPlans = [
  {
    name: "免费用户",
    icon: "ri-user-line",
    badge: "基础",
    desc: "不登录也可浏览部分内容，登录后可保存收藏与进度。",
    features: ["基础清晰度播放", "收藏与观看记录", "标准弹幕体验", "可跨端同步进度"],
    highlight: false,
  },
  {
    name: "标准会员",
    icon: "ri-vip-crown-line",
    badge: "推荐",
    desc: "面向日常观看用户，解锁更高清晰度与更少干扰。",
    features: ["更高清晰度播放", "减少片头广告等待", "弹幕样式自定义", "多设备同时登录"],
    highlight: true,
  },
  {
    name: "VIP 会员",
    icon: "ri-vip-diamond-line",
    badge: "尊享",
    desc: "面向高频观看用户，享受完整的画质与特权组合。",
    features: ["全部清晰度与高码率", "专属 VIP 标识", "离线缓存更多内容", "优先体验新功能"],
    highlight: false,
  },
];

export const vipPerks = [
  { icon: "ri-advertisement-line", title: "更少广告打扰", desc: "在常规播放流程中减少片头等待与插播提示，让观看衔接更连贯。" },
  { icon: "ri-4k-line", title: "高清晰度优先", desc: "可优先选择更高清晰度与更高码率，画面细节在大屏上表现更完整。" },
  { icon: "ri-download-2-line", title: "离线缓存扩容", desc: "缓存条目与数量上限更高，出差或通勤前可提前准备好想看的内容。" },
  { icon: "ri-vip-diamond-line", title: "专属身份标识", desc: "昵称旁展示 VIP 标识，在弹幕与评论区中更易被识别。" },
  { icon: "ri-rocket-line", title: "新功能优先体验", desc: "新的播放能力与交互功能会先在 VIP 用户中开放试用。" },
  { icon: "ri-customer-service-2-line", title: "优先问题反馈", desc: "遇到播放或账号问题时，反馈通道会得到更快的响应与跟进。" },
];

export const danmakuFeatures = [
  { icon: "ri-toggle-line", title: "一键开关", desc: "在播放器控制栏即可开启或关闭弹幕，设置会在下次播放时保留。" },
  { icon: "ri-font-size-2", title: "样式可调", desc: "支持调节字号、透明度与滚动速度，找到适合自己的阅读节奏。" },
  { icon: "ri-filter-3-line", title: "关键词过滤", desc: "可屏蔽指定关键词与屏蔽词列表，减少无关内容对观看的干扰。" },
  { icon: "ri-history-line", title: "历史弹幕回放", desc: "已发送的弹幕可在个人记录中查看与管理，方便回顾与整理。" },
];

export const danmakuSamples = [
  { time: "00:12", text: "这段配乐太好听了" },
  { time: "00:34", text: "画面质感很舒服" },
  { time: "01:05", text: "前方高能，注意看细节" },
  { time: "01:48", text: "这个转场处理得很自然" },
  { time: "02:20", text: "已经在追第二遍了" },
];

export const collectionCategories = ["全部", "电影", "剧集", "纪录片", "综艺"];

export const collectionItems = [
  {
    title: "长夜将至",
    category: "电影",
    meta: "科幻 · 剧情",
    note: "近未来设定下的城市群像，节奏克制，适合安静观看。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimal%20movie%20poster%20of%20a%20dark%20rainy%20city%20skyline%20glowing%20with%20warm%20amber%20lights%2C%20moody%20atmosphere%2C%20deep%20rust%20and%20cream%20tones%2C%20grain%20texture%2C%20elegant%20artistic%20composition%2C%20no%20text&width=600&height=880&seq=poster-night-01&orientation=portrait",
  },
  {
    title: "红土纪事",
    category: "电影",
    meta: "剧情 · 家庭",
    note: "以乡村家庭为切口的长篇叙事，细节扎实，情感含蓄。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimal%20movie%20poster%20of%20red%20earth%20fields%20at%20golden%20hour%2C%20warm%20terracotta%20and%20amber%20palette%2C%20soft%20dust%20in%20air%2C%20painterly%20texture%2C%20elegant%20artistic%20composition%2C%20no%20text&width=600&height=880&seq=poster-redsoil-01&orientation=portrait",
  },
  {
    title: "雾中灯塔",
    category: "剧集",
    meta: "悬疑 · 剧情",
    note: "多线并行的悬疑剧集，信息逐步释放，适合连着看几集。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20of%20a%20lighthouse%20in%20thick%20fog%20with%20a%20warm%20amber%20beam%2C%20muted%20rust%20and%20cream%20palette%2C%20moody%20atmospheric%20tone%2C%20painterly%20texture%2C%20elegant%20composition%2C%20no%20text&width=600&height=880&seq=poster-lighthouse-01&orientation=portrait",
  },
  {
    title: "沙丘回声",
    category: "剧集",
    meta: "冒险 · 剧情",
    note: "以荒漠探索为主线的剧集，摄影风格突出，环境音细节丰富。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20of%20golden%20sand%20dunes%20at%20sunset%20with%20long%20shadows%2C%20warm%20amber%20and%20rust%20palette%2C%20soft%20haze%2C%20painterly%20texture%2C%20elegant%20artistic%20composition%2C%20no%20text&width=600&height=880&seq=poster-dune-01&orientation=portrait",
  },
  {
    title: "山与海的信",
    category: "纪录片",
    meta: "自然 · 人文",
    note: "记录海岸与山地生活的纪录片，节奏缓慢，画面干净。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimal%20documentary%20poster%20of%20misty%20mountains%20meeting%20a%20calm%20sea%20at%20dawn%2C%20warm%20cream%20and%20soft%20amber%20palette%2C%20gentle%20gradient%20sky%2C%20painterly%20texture%2C%20elegant%20composition%2C%20no%20text&width=600&height=880&seq=poster-mountain-01&orientation=portrait",
  },
  {
    title: "旧巷食光",
    category: "综艺",
    meta: "美食 · 生活",
    note: "走访老街小店的轻综艺，节奏轻松，适合下饭时观看。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimal%20poster%20of%20a%20cozy%20old%20alley%20food%20stall%20with%20warm%20hanging%20lights%2C%20amber%20and%20rust%20tones%2C%20steam%20rising%2C%20painterly%20texture%2C%20elegant%20artistic%20composition%2C%20no%20text&width=600&height=880&seq=poster-food-01&orientation=portrait",
  },
];

export const guideSteps = [
  {
    icon: "ri-download-line",
    title: "选择入口",
    desc: "根据设备选择对应客户端入口：手机选 APP，客厅大屏选电视版，临时使用选网页版。",
  },
  {
    icon: "ri-login-box-line",
    title: "登录账号",
    desc: "使用同一账号登录，收藏、片单与观看进度会自动同步，无需在各端手动整理。",
  },
  {
    icon: "ri-settings-3-line",
    title: "调整偏好",
    desc: "在设置中选择默认清晰度、弹幕样式与缓存路径，之后新播放会沿用这些偏好。",
  },
  {
    icon: "ri-bookmark-line",
    title: "收藏与追更",
    desc: "遇到感兴趣的内容先收藏，加入追更列表后可在片单分区集中查看与继续观看。",
  },
];

export const faqs = [
  {
    q: "茶杯狐影视的 APP 与客户端有什么区别？",
    a: "APP 通常指手机与平板上的移动端应用，客户端则是一个更宽的概念，除移动端外还包含智能电视版与网页版。它们共用同一账号体系，收藏与观看进度在各端保持一致。",
  },
  {
    q: "普通会员和 VIP 会员的主要差别是什么？",
    a: "普通会员侧重日常观看与基础清晰度，VIP 会员在此基础上提供更高清晰度与更高码率、更少广告打扰、更大的离线缓存额度，以及专属身份标识与新功能优先体验。",
  },
  {
    q: "弹幕可以关闭吗？会影响正常观看吗？",
    a: "可以。弹幕在播放器控制栏提供一键开关，关闭后不影响正常播放与其它功能。此外还能调节透明度、字号与滚动速度，并通过关键词过滤减少干扰内容。",
  },
  {
    q: "收藏的内容会保存在哪里？换设备还在吗？",
    a: "收藏与追更列表绑定在账号上。只要在新设备使用同一账号登录，收藏片单会自动同步，观看进度也会尽量保持连续。",
  },
  {
    q: "网页版需要安装插件吗？",
    a: "不需要。网页版直接在浏览器中打开并登录即可使用，适合临时使用或公用设备，关闭窗口后不会留下安装文件。",
  },
  {
    q: "如何提升弱网环境下的观看体验？",
    a: "建议先在设置中选择较低的默认清晰度，或在播放中手动切换档位；同时开启省流模式可以自动限制清晰度，减少卡顿与流量消耗。",
  },
];